import { usePage } from '@wbk/calendar/api';
import { ContentfulSection } from '@wbk/calendar';
import Error404 from '@/components/error/404';
import Seo from '@/components/headers/seo';
import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';
import useLocalization from '@/context/localization/useLocalization';

const Home = () => {
  const { locale } = useLocalization();
  const { data, isLoading, error } = usePage({ lang: locale, limit: 1, where: { slug: 'home' } });

  if (isLoading) {
    return <FullpageAnimatedLogo />;
  }

  if (!data || error) {
    return <Error404 />;
  }

  return (
    <>
      <Seo
        title={data.seo?.title || data.title}
        description={data.seo?.description}
        image={data.seo?.image?.url}
      />
      {data.sectionsCollection.items.map((section, idx) => (
        <ContentfulSection key={section.id + idx} section={section} />
      ))}
    </>
  );
};

export default Home;
